/**
 * copyVoraussichtlicherErntebeginn
 * @param element
 */
window.copyVoraussichtlicherErntebeginn = function(element) {
  if (!$(element).hasClass('inactive')) {
    const sectionID = $(element).data('sectionid');
    $('#voraussichtlicherErntetermin-' + sectionID).val($('#vorschlagVoraussichtlicherErntetermin-' + sectionID).val());
  }
};

/**
 * copyAllVoraussichtlicherErntebeginn
 */
window.copyAllVoraussichtlicherErntebeginn = function() {
  const selectAll = $('#selectAll2')
  if (selectAll.prop('checked') === false){
    selectAll.trigger('click');
  }
  $('.empfehlung-sbr-assume').each(function() {
    $(this).trigger('click');
  });
};

/**
 * updateErnteList
 */
window.updateVoraussichtlicheErntetermineList = function() {
  checkboxLevel('#table-voraussichtlicheErntetermine', '#selectAll', '.select-level', '.select-section', '#editListData, #voraussichtlicheErntetermineVorjahrUebernehmen');
  expanderLevel();
  updateCheckAllState('#table-voraussichtlicheErntetermine', '#selectAll', '.select-level');
};

/**
 * updateCheckboxStates
 * @param selectLevel
 */
window.updateCheckboxStates = function(selectLevel) {
  $(selectLevel + ':checked').each(function() {
    $(this).removeClass('inderterminate');

    // selektierte Row
    const selectedRow = $(this).closest('[data-level]');
    const isChecked = $(this).is(':checked');
    // selektiertes Level
    const rowLevel = selectedRow.data('level');
    if (typeof rowLevel !== 'undefined') {
      // Kinder-Checkboxen selektieren
      let nextUntilSelector = '[data-level="' + rowLevel + '"]';
      if (rowLevel > 1) {
        for (let i = (rowLevel - 1); i >= 1; i--) {
          nextUntilSelector += ',[data-level="' + i + '"]';
        }
      }
      const nextLevel = selectedRow.nextUntil(nextUntilSelector, '[data-level]');
      if (nextLevel.length) {
        nextLevel.find('input[type="checkbox"]' + selectLevel).removeClass('inderterminate').prop('checked', isChecked);
      }

      // wenn alle kinder ausgewählt sind auch das Elternelement auswählen
      let isInderterminate = false;
      if (rowLevel > 1) {
        for (let i = (rowLevel - 1); i >= 1; i--) {
          let parentRow = selectedRow.prevAll('[data-level="' + i + '"]').first();
          let parentRowCheckbox = parentRow.find('input[type="checkbox"]' + selectLevel);
          if (parentRow.length && parentRowCheckbox.length) {
            let parentRowCheckboxState = 'unchecked';
            let parentRowChildren = parentRow.nextUntil('[data-level="' + i + '"]', '[data-level="' + (i + 1) + '"]');

            let parentRowChildrenUncheckedExists = (parentRowChildren.find('input[type="checkbox"]' + selectLevel + ':not(:checked)').length);
            let parentRowChildrenCheckedExists = (parentRowChildren.find('input[type="checkbox"]' + selectLevel + ':checked').length);

            if (parentRowChildrenUncheckedExists === 0 && parentRowChildrenCheckedExists !== 0) {
              parentRowCheckboxState = 'checked';
            } else if (parentRowChildrenUncheckedExists !== 0 && parentRowChildrenCheckedExists !== 0) {
              parentRowCheckboxState = 'inderterminate';
              // inderterminate an die Eltern vererben
              isInderterminate = true;
            } else {
              parentRowCheckboxState = 'unchecked';
            }

            switch (parentRowCheckboxState) {
              case 'checked':
                $(parentRowCheckbox).removeClass('inderterminate').prop('checked', true);
                break;
              case 'inderterminate':
                $(parentRowCheckbox).addClass('inderterminate').prop('checked', false);
                break;
              default:
                if (isInderterminate) {
                  // Vererbung von Inderterminate von Kind
                  $(parentRowCheckbox).addClass('inderterminate').prop('checked', false);
                } else {
                  $(parentRowCheckbox).removeClass('inderterminate').prop('checked', false);
                }
            }
          }
        }
      }
    }

  });
};

/**
 * bindSelectSection
 */
window.bindSelectSection = function() {
  $('input.select-level2').on('click', function() {
        const selectedRow = $(this).closest('div.row');
        let row = selectedRow;
        if (!$(this).hasClass('select-section2')) {
          const rowLevel = selectedRow.data('level');
          let nextUntilSelector = '[data-level="' + rowLevel + '"]';
          if (rowLevel < 4) {
            for (let i = (rowLevel - 1); i >= 1; i--) {
              nextUntilSelector += ',[data-level="' + i + '"]';
            }
            row = selectedRow.nextUntil(nextUntilSelector, '[data-level]');
          }
        }
        if ($(this).prop('checked') === true) {
          row.find('.empfehlung-sbr-assume').removeClass('inactive');
        } else {
          row.find('.empfehlung-sbr-assume').addClass('inactive');
        }
      },
  )
  ;
  $('#selectAll2').on('click', function() {
    if ($(this).prop('checked') === true) {
      $('.empfehlung-sbr-assume').removeClass('inactive');
    } else {
      $('.empfehlung-sbr-assume').addClass('inactive');
    }
  });
};
